import { Col, Row } from "antd";

import { MazakaButton } from "apps/Common/MazakaButton";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useGetContracts } from "./ServerSideStates";
import ListItems from "./Components/ListItems";
import PageTitle from "apps/Common/PageTitle";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";

const ContractIndex = () => {
  const contracts = useGetContracts();
  const navigate = useNavigate();
  return (
    <>
      <CountinueOnMobileApp
        isShowChildren={false}
        isShowDesc
        desc="Sözleşme Yönetimi sekmesi yalnızca web sürümümüzde görüntülenebilir"
        useInWeb={true}
        noDataSrc="https://cdn-icons-png.flaticon.com/512/5545/5545101.png"
      >
        <Col xs={24}>
          <Row gutter={[0, 20]} className="">
            <Col span={24} className="!flex justify-center">
              <PageTitle
                title="Sözleşme Listesi"
                count={contracts?.data?.data?.length || 0}
              />
            </Col>
            <Col xs={24} className="!flex justify-end">
              <MazakaButton
                className="!bg-black !text-white  !text-xs !p-2 md:!p-4 md:!text-sm"
                icon={<PlusOutlined />}
                onClick={() => {
                  navigate("/admin/panel/sozlesme-ekle-guncelle");
                }}
              >
                Sözleşme Ekle
              </MazakaButton>
            </Col>

            <Col xs={24} className="">
              <ListItems />
            </Col>
          </Row>
        </Col>
      </CountinueOnMobileApp>

      <></>
    </>
  );
};

export default ContractIndex;
